import { gql } from '@apollo/client';

export const GET_ALL_USERS = gql`
  query GetAllUsers {
    getAllUsers {
      id
      username
      email
      firstName
      lastName
      role
      rentalRole
      permissions
      isActive
      isVerified
      createdAt
      updatedAt
    }
  }
`;

export const GET_USER_BY_ID = gql`
  query GetUserById($id: ID!) {
    getUserById(id: $id) {
      id
      username
      email
      firstName
      lastName
      role
      permissions
      isActive
      isVerified
      createdAt
      updatedAt
    }
  }
`;

export const GET_CURRENT_USER = gql`
  query GetCurrentUser {
    getCurrentUser {
      id
      username
      email
      firstName
      lastName
      role
      permissions
      isActive
      isVerified
      createdAt
      updatedAt
    }
  }
`;

export const GET_AVAILABLE_PERMISSIONS = gql`
  query GetAvailablePermissions {
    getAvailablePermissions
  }
`;

export const CREATE_USER = gql`
  mutation CreateUserWithPermissions($input: CreateUserInput!) {
    createUserWithPermissions(input: $input) {
      id
      username
      email
      firstName
      lastName
      role
      rentalRole
      permissions
      isActive
      isVerified
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_USER_PERMISSIONS = gql`
  mutation UpdateUserPermissions($input: UpdateUserPermissionsInput!) {
    updateUserPermissions(input: $input) {
      id
      username
      email
      firstName
      lastName
      role
      permissions
      isActive
      isVerified
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUserWithPermissions($input: UpdateUserInput!) {
    updateUserWithPermissions(input: $input) {
      id
      username
      email
      firstName
      lastName
      role
      permissions
      isActive
      isVerified
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUserWithPermissions($userId: ID!) {
    deleteUserWithPermissions(userId: $userId)
  }
`;

export const TOGGLE_USER_STATUS = gql`
  mutation ToggleUserStatus($userId: ID!) {
    toggleUserStatus(userId: $userId) {
      id
      username
      email
      firstName
      lastName
      role
      permissions
      isActive
      isVerified
      createdAt
      updatedAt
    }
  }
`;

export const RESET_USER_PASSWORD = gql`
  mutation ResetUserPassword($userId: ID!) {
    resetUserPassword(userId: $userId)
  }
`;